/** Curtains cover an opening independently of its primary window/door state. */
export function curtainBinding(opening) {
  const b = opening?.creation?.covering;
  return b?.role === 'curtain' && typeof b.inventoryId === 'string'
    && /^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i.test(b.inventoryId)
    && typeof b.roomId === 'string' && Array.isArray(opening.creation.rooms)
    && opening.creation.rooms.includes(b.roomId) ? b : null;
}

export function curtainProjection(binding, inventory, state = {}) {
  const present = inventory != null && Number(inventory.inventory_deleted ?? 0) === 0
    && Number(inventory.item_qty ?? 1) > 0
    && (inventory.v_current == null || !Number.isFinite(Number(inventory.v_current))
      || (inventory.v_max != null && Number(inventory.v_max) <= 0) || Number(inventory.v_current) > 0);
  const open = (state.phase ?? 'closed') === 'open';
  return { inventoryId: binding.inventoryId.toUpperCase(), roomId: binding.roomId,
    present, open, blocksSight: present && !open, blocksLight: present && !open,
    blocksPassage: false, revision: Math.max(0, Math.trunc(Number(state.revision) || 0)) };
}
